import ListProcesses from "@/views/organization/production/query_by_producers/ListProcesses.vue";
import ShowProcess from "@/views/organization/production/query_by_producers/ShowProcess.vue";
import ShowProcessSummary from "@/components/views/organization/production/query_by_producers/show_process/Summary.vue";
import ShowProcessProducers from "@/components/views/organization/production/query_by_producers/show_process/Producers.vue";
import ShowProducer from "@/views/organization/production/query_by_producers/ShowProducer.vue";
import ShowProducerSummary from "@/components/views/organization/production/query_by_producers/show_producer/Summary.vue";
import ShowProducerWeekly from "@/components/views/organization/production/query_by_producers/show_producer/Weekly.vue";
import ShowProducerDetails from "@/components/views/organization/production/query_by_producers/show_producer/Details.vue";
import ShowHarvestedBatch from "@/views/organization/production/query_by_producers/ShowHarvestedBatch.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "production",
  permission: "query_by_producers"
});

export default [
  {
    path: "/org/:organization_id/production/query_by_producers/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },

  {
    path: "/org/:organization_id/production/query_by_producers/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },

  {
    path: "/org/:organization_id/production/query_by_producers/show_process/:harvest_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_summary") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "summary",
        name: routeName("show_process_summary"),
        component: ShowProcessSummary,
        props: true
      },
      {
        path: "producers",
        name: routeName("show_process_producers"),
        component: ShowProcessProducers,
        props: true
      }
    ]
  },

  {
    path: "/org/:organization_id/production/query_by_producers/show_producer/:harvest_process_id/:provider_type/:producer_id",
    name: routeName("show_producer"),
    redirect: { name: routeName("show_producer_summary") },
    component: ShowProducer,
    props: true,
    meta: META,
    children: [
      {
        path: "summary",
        name: routeName("show_producer_summary"),
        component: ShowProducerSummary,
        props: true
      },
      {
        path: "weekly",
        name: routeName("show_producer_weekly"),
        component: ShowProducerWeekly,
        props: true
      },
      {
        path: "details",
        name: routeName("show_producer_details"),
        component: ShowProducerDetails,
        props: true
      }
    ]
  },

  {
    path: "/org/:organization_id/production/query_by_producers/harvested_batch/:harvest_process_id/:provider_type/:producer_id/:harvested_batch_id",
    name: routeName("show_harvested_batch"),
    component: ShowHarvestedBatch,
    props: true,
    meta: META
  }
];
